import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/table/index.js
// module id = null
// module chunks = 